import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSchool: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconSchool"><Path fillRule="evenodd" clipRule="evenodd" d="M6 6.75C6 5.23122 7.23122 4 8.75 4H15.25C16.7688 4 18 5.23122 18 6.75V18.5H19V8H19.25C20.7688 8 22 9.23122 22 10.75V18.5H22.25C22.6642 18.5 23 18.8358 23 19.25C23 19.6642 22.6642 20 22.25 20H1.75C1.33579 20 1 19.6642 1 19.25C1 18.8358 1.33579 18.5 1.75 18.5H2V10.75C2 9.23122 3.23122 8 4.75 8H5V18.5H6V6.75ZM14 18.5V16.25C14 15.5596 13.4404 15 12.75 15H11.25C10.5596 15 10 15.5596 10 16.25V18.5H14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSchool;
